export default __webpack_public_path__ + "static/media/275.f18f6359.svg";